import { TrackingHistory } from "../../../asset/TrackingHistory";
import { DriverManagementEventsTable } from "../DriverManagementEventsTable";
import { Button, CityState, DataSource, Image, Label, Layout, Panel, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutDriverManagementExpand extends Layout {
    buttonSettlementDetails: Button;
    citystateCust: CityState;
    citystateLastStop: CityState;
    imageStopType: Image;
    labelAddress2: Label;
    labelAddress: Label;
    labelContactEmail: Label;
    labelContactName: Label;
    labelContactPhone: Label;
    labelDestinationTimezone: Label;
    labelDestinationWindow: Label;
    labelDriverLastStop: Label;
    labelEmptyMove: Label;
    labelLocationCaption: Label;
    labelLocationName: Label;
    labelManifestId: Label;
    labelOriginOrderId: Label;
    labelOriginTimezone: Label;
    labelOriginWindow: Label;
    labelStatus: Label;
    labelStopType: Label;
    labelTrackingHistory: Label;
    layoutDriverManagementEventsTable: DriverManagementEventsTable;
    layoutTrackingHistory: TrackingHistory;
    panelCustInfo: Panel;
    panelCustomerDetails: Panel;
    panelCustomerInfo: Panel;
    panelDestination: Panel;
    panelLastStop: Panel;
    panelLoad: Panel;
    panelLocation: Panel;
    panelOrderInfo1: Panel;
    panelOrderInfo2: Panel;
    panelOrderInfo3: Panel;
    panelOrderInfo: Panel;
    panelOrigin: Panel;
    panelOriginLocation: Panel;
    panelPositions: Panel;
    panelStopBadges: Panel;
    sourceDriverEvents: DataSource;
    sourceDriverManager: DataSource;
    sourceEquipmentPositionsAndCallins: DataSource;
    tabDispatch: Tab;
    tabDriverEvents: Tab;
    tabExpand: Tabset;
    tabTrackingHistory: Tab;
    textboxCommodity: Textbox;
    textboxCustName: Textbox;
    textboxDestinationAddress: Textbox;
    textboxDestinationCity: Textbox;
    textboxDestinationName: Textbox;
    textboxDestinationState: Textbox;
    textboxDestinationZip: Textbox;
    textboxLastStopArrival: Textbox;
    textboxLastStopDeparture: Textbox;
    textboxManifestCommodities: Textbox;
    textboxManifestContactIds: Textbox;
    textboxManifestCustomers: Textbox;
    textboxManifestOperationsUsers: Textbox;
    textboxManifestOrderValue: Textbox;
    textboxManifestTrailerTypes: Textbox;
    textboxOpsUserName: Textbox;
    textboxOrderValue: Textbox;
    textboxOriginAddress: Textbox;
    textboxOriginCity: Textbox;
    textboxOriginName: Textbox;
    textboxOriginState: Textbox;
    textboxOriginZip: Textbox;
    textboxPieces: Textbox;
    textboxStopsPickDrop: Textbox;
    textboxTemp: Textbox;
    textboxTrailerType: Textbox;
    textboxWeight: Textbox;
}
